module.exports = __webpack_public_path__ + "crm_static/img/wx.24dfd617.png";